import React from 'react';
import { Box, Divider } from '@mui/material';

import { SearchField, CompressionSwitch } from './components';

const Search = (props) => {
    const { disabled, searchValue: savedSearch, searchText, handleSearchChange, handleSwitch } = props;

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <SearchField
                    handleSearchChange={handleSearchChange}
                    searchText={searchText}
                    savedSearch={savedSearch}
                    disabled={disabled}
                />

                <CompressionSwitch handleSwitch={handleSwitch} />
            </Box>

            <Divider sx={{ marginTop: (theme) => theme.spacing(2) }} />
        </>
    );
};

export default Search;
